<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-image-size-select-large"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="12" class="text-right mb-5">
          <v-btn
              class="btn-add-templates"
              @click="addThemes"
          >
            Add Themes
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="white mx-1">
        <v-col cols="12" class="mt-n2">
          <v-data-table
              :headers="headers"
              :items="listThemes"
              class="elevation-1"
              :sort-by="['index']"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
          <v-dialog
              v-model="dialogAddTheme"
              v-if="dialogAddTheme"
              max-width="500px"
              persistent
          >
            <v-card class="pa-4">
              <ValidationObserver ref="addTheme">
                <v-card-title>
                  <span class="text-h5 mx-3">Add Template Theme</span>
                </v-card-title>
                <v-card-text>
                  <v-row align="center" justify="center">
                    <v-col class="mt-4" cols="11">
                      <div class="mb-2 primary--text">Name<span class="necessary">(*)</span></div>
                      <ValidationProvider
                          name="name"
                          rules="required"
                          v-slot="{ errors }"
                      >
                        <v-text-field
                            filled
                            label="Name"
                            placeholder="Enter name"
                            v-model="name"
                        ></v-text-field>
                        <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="11">
                      <div class="mb-2 primary--text">Index<span class="necessary">(*)</span></div>
                      <ValidationProvider
                          name="index"
                          rules="required|numeric"
                          v-slot="{ errors }"
                      >
                        <v-text-field
                            filled
                            label="Index"
                            placeholder="Enter position"
                            v-model="index"
                        ></v-text-field>
                        <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-row align="center" justify="center" class="mb-4">
                    <v-btn class="mr-5" @click="dialogAddTheme = false">CANCEL</v-btn>
                    <v-btn class="btn" @click="save">SAVE</v-btn>
                  </v-row>
                </v-card-actions>
              </ValidationObserver>

            </v-card>
          </v-dialog>
          <v-dialog
              v-model="dialogEditTheme"
              v-if="dialogEditTheme"
              max-width="500px"
              persistent
          >
            <v-card class="pa-4">
              <ValidationObserver ref="editTheme">
                <v-card-title>
                  <span class="text-h5 mx-3">Edit Template Theme</span>
                </v-card-title>
                <v-card-text>
                  <v-row align="center" justify="center">
                    <v-col class="mt-4" cols="11">
                      <div class="mb-2 primary--text">Name<span class="necessary">(*)</span></div>
                      <ValidationProvider
                          name="name"
                          rules="required"
                          v-slot="{ errors }"
                      >
                        <v-text-field
                            filled
                            label="Name"
                            placeholder="Enter name"
                            v-model="themeDetail.name"
                        ></v-text-field>
                        <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="11">
                      <div class="mb-2 primary--text">Index<span class="necessary">(*)</span></div>
                      <ValidationProvider
                          name="index"
                          rules="required|numeric"
                          v-slot="{ errors }"
                      >
                        <v-text-field
                            filled
                            label="Index"
                            placeholder="Enter index"
                            v-model="themeDetail.index"
                        ></v-text-field>
                        <span class="validate-error red--text">
                    {{ errors[0] }}
                  </span>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-row align="center" justify="center" class="mb-4">
                    <v-btn class="mr-5" @click="dialogEditTheme = false">CANCEL</v-btn>
                    <v-btn class="btn" @click="update">UPDATE</v-btn>
                  </v-row>
                </v-card-actions>
              </ValidationObserver>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  DELETE_TEMPLATE_THEMES,
  GET_DETAIL_TEMPLATE_THEMES,
  GET_LIST_TEMPLATE_THEMES,
  SAVE_TEMPLATE_THEMES, UPDATE_TEMPLATE_THEMES
} from "@/store/modules/themes";
import {
  ValidationProvider,
  ValidationObserver,
  localize,
} from "vee-validate/dist/vee-validate.full";

export default {
  name: "Themes",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      page: "Templates",
      breadcrumbs: [
        {
          text: "Templates Setting",
          disabled: true,
        },
        {
          text: "Themes",
          disabled: false,
        },
      ],
      headers: [
        {text: "ID", value: "id", align: "start"},
        {text: "Name", value: "name"},
        {text: "Index", value: "index"},
        {text: "Actions", value: "actions", sortable: false},
      ],
      dialogAddTheme: false,
      dialogEditTheme: false,
      name: '',
      description: '',
      size: '',
      index: '',
    }
  },
  computed: {
    ...mapGetters({
      listThemes: "listThemes",
      themeDetail: "themeDetail",
    })
  },

  async created() {
    await this.$store.dispatch(GET_LIST_TEMPLATE_THEMES);
  },
  mounted() {
    localize({
      vi: {
        names: {
          name: "Name",
          index: "Index",
        },
        messages: {
          required: "{_field_} " + "is empty!",
          numeric: "{_field_} " + "is not a number!",
        },
      },
    });
    localize("vi");
  },
  methods: {
    editItem(id) {
      this.$store.dispatch(`${GET_DETAIL_TEMPLATE_THEMES}`, id).then((data) => {
        if (data) {
          this.dialogEditTheme = true;
        }
      });
    },
    deleteItem(id) {
      confirm('Are you sure you want to delete ?') &&
      this.$store.dispatch(`${DELETE_TEMPLATE_THEMES}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_LIST_TEMPLATE_THEMES);
        }
      })
    },
    addThemes() {
      this.dialogAddTheme = true
    },
    async update() {
      let result = this.$refs.editTheme.validate();
      if (result) {
        if (!this.themeDetail.name || !this.themeDetail.index ) {
          return false;
        } else {
          await this.$store.dispatch(`${UPDATE_TEMPLATE_THEMES}`, this.themeDetail).then((data) => {
            if (data.data.status == 1) {
              this.$toasted.success('Update successful!', {
                duration: 1000,
                position: 'top-center'
              })
              this.dialogEditTheme = false
              this.$store.dispatch(GET_LIST_TEMPLATE_THEMES);
            } else {
              alert(data.data.errors)
            }
          });
        }
      }

    },
    async save() {
      let result = this.$refs.addTheme.validate();
      if (result) {
        if (!this.name || !this.index) {
          return false;
        } else {
          let data = {
            name: this.name,
            index: this.index
          }
          await this.$store.dispatch(`${SAVE_TEMPLATE_THEMES}`, data).then((data) => {
            if (data.data.status == 1) {
              this.$toasted.success('Update successful!', {
                duration: 1000,
                position: 'top-center'
              })
              this.dialogAddTheme = false
              this.name = ''
              this.index = ''
              this.$store.dispatch(GET_LIST_TEMPLATE_THEMES);
            } else {
              alert(data.data.errors)
            }
          });
        }
      }


    }
  }
}
</script>

<style scoped>
.btn-add-templates {
  background-color: #71BEC8 !important;
  color: white !important;
  border-radius: 36px !important;
}

.btn {
  background-color: #71BEC8 !important;
  color: white !important;
}

.necessary {
  color: red;
}

</style>